import React from 'react'

import { useTranslation } from 'react-i18next'
import { FieldProps } from '../../../../../../../@types/types'
import { OtherFacilitiesScreenValidationResult } from '../../../../../../../@types/validation-types'
import TextInput from '../../../../../../common/inputs/textInput/TextInput'
import { getDefaultClasses } from '../../../../../../../utils/style-utils'

const AdditionalAreaField: React.FC<FieldProps<OtherFacilitiesScreenValidationResult>> = ({
  screenName,
  insertionData,
  validationMessages,
  wrapperClassName = getDefaultClasses('full'),
  onChange,
}) => {
  const { t } = useTranslation()
  return (
    <div className={wrapperClassName}>
      <TextInput
        id='additional-area'
        propertyName='additionalArea'
        placeholder=''
        label={<span>{t('wizard.screen.otherFacilities.additionalArea', 'Additional Area')}</span>}
        value={insertionData.additionalArea}
        maxLength={11}
        type='text'
        affixRight='unit'
        unitRight='sqm'
        errors={validationMessages?.additionalArea ?? []}
        doOnFieldChange={(property, value) => onChange({ screen: screenName, property }, value)}
      />
    </div>
  )
}

export default AdditionalAreaField
